// extracted by mini-css-extract-plugin
export var hidden = "_ty-0";